import React from 'react'
import ReactPaginate from 'react-paginate'
import { GrNext, GrPrevious } from "react-icons/gr";


const Pagination = ({ pageCount, onPress }) => {
  const handlePageClick = (data) => {
    onPress(data.selected + 1)
  }
  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel={<GrNext/>}
      onPageChange={handlePageClick}
      marginPagesDisplayed={2}
      pageRangeDisplayed={2}
      pageCount={pageCount}
      previousLabel={<GrPrevious/>}
      containerClassName={"pagination justify-content-center p-3"}
      pageClassName={"page-item "}
      pageLinkClassName={"page-link"}
      previousClassName={"prev-btn bg-warning"}
      nextClassName={"next-btn bg-warning"}
      previousLinkClassName={"text-center text-white d-inline-block w-100 h-100"}
      nextLinkClassName={"text-center text-white d-inline-block w-100 h-100"}
      breakClassName={"page-item"}
      breakLinkClassName={"page-link"}
      activeClassName={"active"}
    />
  )
}

export default Pagination
